module.exports = __webpack_public_path__ + "media/images/products/longlife/icon/chevron-up-green-f033f296e5e4a7477e1a8d472086f4fd.svg";